export default __webpack_public_path__ + "static/media/InsideSkinHairNails_11.66ebc370.png";